import classes from "./Header2.module.css";
import { FaHouse, FaFutbol, FaTrophy, FaClock } from "react-icons/fa6";
import { FaUser } from "react-icons/fa";
import { useNavigate } from 'react-router-dom';
import { useDispatch, useSelector } from "react-redux";
import { useTranslation } from "react-i18next";
import i18n from "../../locales/i18n";
import { useEffect } from "react";
import { setLanguage } from "../../store/slices/languageSlice";

const Header2 = ({ active, hide }) => {
    const navigate = useNavigate();
    const dispatch=useDispatch();

    const { selectedLanguage } = useSelector((state) => state.languageSlice);

    const { t } = useTranslation();

    useEffect(() => {
        if (selectedLanguage && i18n.language !== selectedLanguage) {
            i18n.changeLanguage(String(selectedLanguage));
        }
    }, [selectedLanguage, i18n]);

    return (
        <header className={classes.header}>
            {/* Logo strip */}
            <div className={classes.logoStrip}>
                <div className={classes.logoInner}>
                    <img src="/assets/images/logo.png" alt="logo" className={classes.logo_img} />
                    {/* <span className={classes.logoEmoji}>⚽</span>
                    <span className={classes.logoWordmark}>
                        <em>Football</em> Masters
                    </span> */}
                </div>
                {/* Decorative pitch line */}
                <div className={classes.pitchLine} />

                <select
                    id="lang"
                    name="lang"
                    className={classes.dropdown}
                    value={selectedLanguage}
                    onChange={(event) => {
                        dispatch(setLanguage(event.target.value));
                    }}
                >
                    <option value="0">English</option>
                    <option value="1">French</option>
                </select>
            </div>

            {/* Nav strip */}
            {!hide && (
                <nav className={classes.nav}>
                    <div className={classes.navInner}>
                        {[
                            { icon: FaHouse, label: t("203"), path: "/home", id: 0 },
                            { icon: FaFutbol, label: t("204"), path: "/my-matches", id: 1 },
                            { icon: FaClock, label: t("205"), path: "/live", id: 2 },
                            { icon: FaTrophy, label: t("206"), path: "/leaderboard", id: 3 },
                            { icon: FaUser, label: t("207"), path: "/profile", id: 4 },
                        ].map(({ icon: Icon, label, path, id }) => (
                            <button
                                key={id}
                                type="button"
                                className={`${classes.navItem} ${active === id ? classes.navItemActive : ''}`}
                                onClick={() => navigate(path)}
                            >
                                <Icon className={classes.navIcon} />
                                <span className={classes.navLabel}>{label}</span>
                                {active === id && <span className={classes.activePill} />}
                            </button>
                        ))}
                    </div>
                </nav>
            )}
        </header>
    );
}

export default Header2;